<div class="wrapper">
  <label class="label">{{ label }}</label>
  <p class="description m-0">{{ value || '-' }}</p>
</div>
